import { Consent as ConsentComponent } from './Consent';
import { ConsentClientContextProvider } from './State/consentClientState';

export function Consent() {
  return (
    <ConsentClientContextProvider>
      <ConsentComponent />
    </ConsentClientContextProvider>
  );
}
